export default {
    jobAcceptedMessage() {
        return this.$store.state.settings?.filter(setting => {
            return setting.id === 'job_accepted_message'
        })[0]?.value
    },
    jobDeniedMessage() {
        return this.$store.state.settings?.filter(setting => {
            return setting.id === 'job_denied_message'
        })[0]?.value
    },
    jobCancelledMessage() {
        return this.$store.state.settings?.filter(setting => {
            return setting.id === 'job_cancelled_message'
        })[0]?.value
    },
    jobTotalFee() {
        return this.job.fee * this.job.event.totalDays ?? 0
    },
    jobType() {
        return this.allAvailableJobTypes.filter(jobType => {return jobType.code === this.job.type })[0]?.label
    }
}
